import { useMemo, useRef, useState } from 'react';
import type { Member } from '../../lib/contract';

/** Searchable people picker (works with 3 users or 300). */
export function UserCombo({ members, value, onPick, placeholder, withRole = true }:
  { members: Member[]; value?: Member | null; onPick: (m: Member | null) => void; placeholder?: string; withRole?: boolean }) {
  const [open, setOpen] = useState(false);
  const [q, setQ] = useState(value ? (withRole ? `${value.name} — ${value.role}` : value.name) : '');
  const rootRef = useRef<HTMLDivElement>(null);

  const opts = useMemo(() => {
    const needle = q.toLowerCase().trim();
    return members.filter((m) => (m.name + ' ' + m.role).toLowerCase().includes(needle)).slice(0, 60);
  }, [q, members]);

  function choose(m: Member) {
    setQ(withRole ? `${m.name} — ${m.role}` : m.name);
    setOpen(false);
    onPick(m);
  }

  return (
    <div className="combo" ref={rootRef}>
      <input
        className="input combo-input"
        placeholder={placeholder ?? 'Search people…'}
        value={q}
        autoComplete="off"
        onFocus={() => setOpen(true)}
        onChange={(e) => { setQ(e.target.value); setOpen(true); onPick(null); }}
        onBlur={() => setTimeout(() => setOpen(false), 120)}
      />
      <span className="combo-caret">▾</span>
      {open && (
        <div className="combo-list" style={{ display: 'block' }}>
          {opts.length === 0
            ? <div className="combo-empty">No people match that search</div>
            : opts.map((m) => (
                <div key={m.id} className="combo-opt" onMouseDown={(e) => { e.preventDefault(); choose(m); }}>
                  <span>{m.name}</span><span className="cc">{m.role}</span>
                </div>
              ))}
        </div>
      )}
    </div>
  );
}
